var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-menu" },
    [
      _vm.device !== "mobile"
        ? [
            _vm.showSearch ? void 0 : _vm._e(),
            _vm.showSearch
              ? [
                  _c("search", {
                    staticClass: "right-menu-item",
                    attrs: { id: "header-search" },
                  }),
                ]
              : _vm._e(),
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.$t("navbar.notice"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "right-menu-item hover-effect",
                    on: {
                      click: function ($event) {
                        return _vm.$refs.MessageList.init()
                      },
                    },
                  },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.messageCount,
                          hidden: !_vm.messageCount,
                          max: 99,
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "icon-ym icon-ym-header-message",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        : _vm._e(),
      _c(
        "el-dropdown",
        {
          staticClass: "avatar-container right-menu-item hover-effect",
          attrs: { trigger: "hover" },
        },
        [
          _c(
            "div",
            { staticClass: "avatar-wrapper" },
            [
              _vm.userInfo.headIcon
                ? _c("el-avatar", {
                    staticClass: "user-avatar",
                    attrs: {
                      size: 26,
                      src: _vm.define.comUrl + _vm.userInfo.headIcon,
                    },
                  })
                : _vm._e(),
              _c("span", [_vm._v(_vm._s(_vm.userInfo.userName))]),
              _c("i", { staticClass: "el-icon-arrow-down" }),
            ],
            1
          ),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "router-link",
                { attrs: { to: "/profile" } },
                [
                  _c("el-dropdown-item", [
                    _c("i", { staticClass: "icon-ym icon-ym-header-userInfo" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("navbar.profile")) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-dropdown-item",
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.lock($event)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "icon-ym icon-ym-header-lockScreen" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("navbar.lockScreen")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "el-dropdown-item",
                {
                  attrs: { divided: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.handleLogout($event)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "icon-ym icon-ym-header-loginOut" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("navbar.logOut")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tooltip",
        { attrs: { content: _vm.$t("navbar.setting"), placement: "bottom" } },
        [
          _vm.showSettings
            ? _c(
                "div",
                {
                  staticClass: "right-menu-item hover-effect",
                  on: {
                    click: function ($event) {
                      return _vm.$refs.Settings.init()
                    },
                  },
                },
                [_c("i", { staticClass: "icon-ym icon-ym-header-pannel" })]
              )
            : _vm._e(),
        ]
      ),
      _c("MessageList", { ref: "MessageList", on: { read: _vm.read } }),
      _c("Settings", { ref: "Settings" }),
      _c("UserList", {
        ref: "UserList",
        on: { changeTwinkle: _vm.changeTwinkle },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }